// extracted by mini-css-extract-plugin
export default {"container":"R0-z","heading":"S0-z","links":"T0-z","copy":"U0-z","subCopy":"V0-z","linksLeft":"W0-z","linksCenter":"X0-z","linksRight":"Y0-z","link":"Z0-z","onlyLink":"_0-z"};